<template lang="pug">
	.main
		LoadingScreen(v-if='isLoading')
		.select-contract(v-else)
			.heading
				img.logo(:src="logo")
				.headingText Select a contract
			.contracts
				.contract(v-for='contract in contracts' @click='selectContract( contract )')
					p {{ contract.contractName }} - {{ contract.contractNum }}
</template>

<script>
import { GetContractList } from '@/lib/API';
import LoadingScreen from '@/components/LoadingScreen';
import logo from '@/assets/images/logo.png';

export default {
	name       : 'select-contact',
	components : {
		LoadingScreen
	},
	data : () => ( {
		contracts : [],
		isLoading : false,
		logo,
	} ),

	created() {
		this.$store.commit('hideNavbar');
		if(typeof (this.$store.getters.getAccessToken) === 'undefined') {
			setTimeout(() => {
			GetContractList()
				.then( ( contracts ) => {
					this.contracts = contracts;
					if(contracts.length === 1) {
						this.selectContract( contracts[0] );
					}
				} );
			}, 300);
		} else {
			GetContractList()
				.then( ( contracts ) => {
					this.contracts = contracts;
					if(contracts.length === 1) {
						this.selectContract( contracts[0] );
					}
				} );
		}
	},

	methods : {

		async selectContract( contract ) {
			this.$store.dispatch( 'selectContract', contract );
			const args = {
				ContractNum  : contract.contractNum,
				ContractName : contract.contractName,
			};
			this.isLoading = true;
			try {
				await this.$store.dispatch( 'getCustomStatus', contract.contractNum );
				await this.$store.dispatch( 'setEntitySummaryDataPayableYield', contract.contractNum );
				await this.$store.dispatch( 'setEntitySummaryDataInsectDamage', contract.contractNum );
				await this.$store.dispatch( 'setEntitySummaryDataQualitySummary', contract.contractNum );
				await this.$store.dispatch( 'setVarietySummaryDataPayableYield', contract.contractNum );
				await this.$store.dispatch( 'setVarietySummaryDataQualitySummary', contract.contractNum );
				await this.$store.dispatch( 'setVarietySummaryDataInsectDamage', contract.contractNum );
				await this.$store.dispatch( 'setFieldSummaryDataQualitySummary', contract.contractNum );
				await this.$store.dispatch( 'setFieldSummaryDataInsectDamage', contract.contractNum );
				await this.$store.dispatch( 'setFieldSummaryDataPayableYield', contract.contractNum );
				this.isLoading = !this.isLoaded();
			}
			catch ( err ) {
        console.log('loading contracts error');
				console.log( err );
			}
			finally {
				this.isLoading = false;
				console.log( 'done' );
				this.$store.commit('showNavbar');
				this.$router.push( { path : 'home' } );
			}


		},
		isLoaded() {
			if (	this.$store.getters.entitySummaryData.InsectDamage.chartData.length
				&& this.$store.getters.entitySummaryData.PayableYield.chartData.length
				&& this.$store.getters.entitySummaryData.QualitySummary.chartData.length
				&& this.$store.getters.varietySummaryData.InsectDamage.chartData.length
				&& this.$store.getters.varietySummaryData.PayableYield.chartData.length
				&& this.$store.getters.varietySummaryData.QualitySummary.chartData.length
				&& this.$store.getters.fieldSummaryData.InsectDamage.chartData.length
				&& this.$store.getters.fieldSummaryData.PayableYield.chartData.length
				&& this.$store.getters.fieldSummaryData.QualitySummary.chartData.length
				&& this.$store.getters.getCustomStatus
			) return true;
			return false;
		}
	},
	computed : {
		loading() {
			if (	this.$store.getters.entitySummaryData.InsectDamage.chartData.length
				&& this.$store.getters.entitySummaryData.PayableYield.chartData.length
				&& this.$store.getters.entitySummaryData.QualitySummary.chartData.length
				&& this.$store.getters.varietySummaryData.InsectDamage.chartData.length
				&& this.$store.getters.varietySummaryData.PayableYield.chartData.length
				&& this.$store.getters.varietySummaryData.QualitySummary.chartData.length
				&& this.$store.getters.fieldSummaryData.InsectDamage.chartData.length
				&& this.$store.getters.fieldSummaryData.PayableYield.chartData.length
				&& this.$store.getters.fieldSummaryData.QualitySummary.chartData.length
			) return true;
			return false;
		}
	}


};
</script>

<style lang="scss">
	.main {
		font-family: $font-serif;
		font-style: normal;
		color: #407765;
		background: url(("../../../public/img/home-page-background.png")) no-repeat;
		background-color: #f2f8f6;
		background-position: right 0px bottom 298px;
		background-repeat: no-repeat;
		background-size: cover;
			-webkit-background-size: cover;
			-moz-background-size: cover;
			-o-background-size: cover;
			.chartCon {
				height:44vh;
			}
		
		height:88vh;
			.select-contract {
				display: flex;
				flex-direction: column;
				align-items: center;
				height:100%;
					.heading {
						height:30%;
						.headingText {
							height:30%;
							font-size:5vmin;
						}
						.logo {
							height:70%;
						}
					}
					.contracts {
						width: 80vw;
						font-size:2vmin;
						overflow:auto;

						background-color: white;
						box-shadow: .1vmin .1vmin .4vmin #000;
						border-radius: 10px;
						padding: 8px 0px;

							.contract {
								padding: 8px 0px;
								cursor: pointer;

								p {
									margin : 0px;
                  font-size: 1.2rem;
								}

									&:hover {
										background-color: darken( $bg-color, 20 );
									}
							}
					}
			}
	}
</style>
